import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './assessment-invitation-modal.styles'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import EmailInput from 'pobble-components/dist/email-input'
import { ColorsInfo } from 'pobble-components/dist/email-input/utils'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import InfoMessage from './info-message/info-message.container'
import { useRecaptcha } from 'pobble-components/dist/recaptcha'

const AssessmentInvitationModal = ({
  classes,
  isOpen,
  onSubmit,
  requestClose,
  id
}) => {
  const [selectedEmails, setSelectedEmails] = useState([])
  const [pending, setPending] = useState(false)

  const { Recaptcha, recaptchaProps, getReCaptchaToken } = useRecaptcha()

  return (
    <Modal isOpen={isOpen} closeButton requestClose={requestClose}>
      <ModalHeader>Invite contributors</ModalHeader>
      <ModalContent className={classes.modalContent}>
        <FormLabel spaceBetween small>
          To: {!!selectedEmails.length && <ColorsInfo />}
        </FormLabel>
        <EmailInput
          cacheKey="moderationInvitationEmailCache"
          selected={selectedEmails}
          onChange={setSelectedEmails}
        />
        <InfoMessage id={id} />
        <Recaptcha {...recaptchaProps} />
      </ModalContent>
      <ModalFooter alignRight>
        <Button
          pending={pending}
          disabled={!selectedEmails.length}
          action={() => {
            setPending(true)
            getReCaptchaToken(token => {
              onSubmit(selectedEmails, token).then(() => {
                setSelectedEmails([])
                setPending(false)
              })
            })
          }}
          tall>
          {!pending && 'Send invitation'}
          {pending && 'Sending...'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default injectSheet(styles)(AssessmentInvitationModal)
